<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-row no-gutters>
        <v-col>
          <v-card class="pa-2 ma-2" outlined tile>
            <!-- toolbar -->
            <reference-tool-bar
              :title="options.title.main"
              :editedIndex="editedIndex"
              :createItemTitle="options.title.create"
              :formTitle="formTitle"
              :dialog="dialog"
              @save="save"
              @close="close"
              @open="open"
            >
              <template v-slot:formCreateEdit>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.nameRu"
                    label="Наименование"
                    :hint="`Введите тип организации`"
                    :rules="[rules.required, rules.alfabet]"
                    autofocus
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.nameKz"
                    label="NameKz"
                    :hint="`Допускаются только буквы`"
                    :rules="[rules.required, rules.min]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.nameEn"
                    label="NameEn"
                    :hint="`Допускаются только буквы`"
                    :rules="[rules.required, rules.min]"
                  ></v-text-field>
                </v-flex> -->
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.shortName"
                    label="Короткое имя"
                    :rules="[rules.required, rules.alfabetRu]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-select
                    v-model="statusSelect"
                    :hint="`Идентификатор статуса - [${statusSelect.id}]`"
                    :items="statusList"
                    item-text="nameRu"
                    item-value="id"
                    label="Статус"
                    persistent-hint
                    return-object
                    single-line
                  >
                  </v-select>
                </v-flex>
              </template>
            </reference-tool-bar>
            <!--Таблица с данными-->
            <reference-table
              :headers="options.headers"
              :items="options.data"
              @edit-item="editItem($event)"
              @remove-item="removeItem($event)"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { Vue } from "vue-property-decorator";
import { get } from "vuex-pathify";
import { mapActions } from "vuex";
import { rules } from "@/util/rules";

export default Vue.extend({
  name: "OrganizationType.vue",
  components: {
    ReferenceTable: () => import("@/components/reference/ReferenceTable.vue"),
    ReferenceToolBar: () =>
      import("@/components/reference/ReferenceToolBar.vue")
  },
  computed: {
    options: get("reference/optionsOrganizationType"),
    statusList: get("reference/getStatus"),
    formTitle() {
      return this.editedIndex === -1 ? "Создать" : "Редактировать";
    }
  },
  data() {
    return {
      rules,
      dialog: false,
      editedIndex: -1,
      statusSelect: 0
    };
  },
  methods: {
    ...mapActions({
      fetchReference: "reference/fetchOrganizationTypes",
      fetchStatus: "reference/fetchStatus"
    }),
    initialize() {
      this.fetchStatus().then(result => {
        this.statusSelect = this.statusList.find(
          status => status.name == "Active"
        );
      });
      this.fetchReference();
    },
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.options.editedItem = Object.assign({}, this.options.defaultItem);
        this.statusSelect = this.statusList[0];
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      const model = {
        statusId: this.statusSelect.id,
        id: this.options.editedItem.id,
        nameRu: this.options.editedItem.nameRu,
        nameKz: this.options.editedItem.nameKz,
        nameEn: this.options.editedItem.nameEn,
        shortName: this.options.editedItem.shortName
      };
      if (this.editedIndex > -1) {
        this.$http.put(this.options.path.base, model).then(response => {
          if (response.status === "Ok") this.initialize();
        });
      } else {
        model.id = 0;
        this.$http.post(this.options.path.base, model).then(response => {
          if (response.status === "Ok") this.initialize();
        });
      }
      this.close();
    },
    editItem(item) {
      this.editedIndex = this.options.data.indexOf(item);
      this.options.editedItem = Object.assign({}, item);
      this.statusSelect = { id: item.status.id, name: item.status.NameRu };
      this.open();
    },
    removeItem(item) {
      if (confirm("Вы уверены что хотите удалить данный тип?")) {
        const model = Object.assign({}, item);
        this.$http
          .delete(this.options.path.base, { data: model })
          .then(response => {
            if (response.status === "Ok") this.initialize();
          });
      }
    }
  },
  created() {
    this.initialize();
  }
});
</script>
